import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mb-5 pb-5 mb-md-0 pb-md-0" }
const _hoisted_2 = { class: "container-fluid skin-body" }
const _hoisted_3 = { class: "row" }

import { app } from "@/guiide/ts/app";
const isAnon = true;

export default /*@__PURE__*/_defineComponent({
  __name: 'AppAnon',
  setup(__props) {

app.initialise(isAnon);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})